import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const History = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2.5C6.8224 2.5 5.73163 2.86972 4.8368 3.5H5.5C5.77614 3.5 6 3.72386 6 4C6 4.27614 5.77614 4.5 5.5 4.5H3.5C3.22386 4.5 3 4.27614 3 4V2C3 1.72386 3.22386 1.5 3.5 1.5C3.77614 1.5 4 1.72386 4 2V2.87621C5.10276 2.01423 6.49161 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 7.72386 1.72386 7.5 2 7.5C2.27614 7.5 2.5 7.72386 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5ZM8.50003 5C8.50003 4.72386 8.27617 4.5 8.00003 4.5C7.72389 4.5 7.50003 4.72386 7.50003 5V7.7925L6.14645 9.14605C5.95119 9.34131 5.95118 9.6579 6.14644 9.85316C6.3417 10.0484 6.65829 10.0484 6.85355 9.85317L8.35358 8.35317C8.44735 8.2594 8.50003 8.13222 8.50003 7.99961V5Z"
      />
    </svg>
  )
})

export default History
